export default {
  analytics: {
    cookie: ["collect", "_ga", "_gat", "_gid"],
  },
};
